import { render, staticRenderFns } from "./helpIssueVps.html.vue?vue&type=template&id=7d8c71ef"
import script from "./helpIssueVps.html.vue?vue&type=script&lang=js"
export * from "./helpIssueVps.html.vue?vue&type=script&lang=js"
import style0 from "./helpIssueVps.html.vue?vue&type=style&index=0&id=7d8c71ef&prod&lang=scss"
import style1 from "./helpIssueVps.html.vue?vue&type=style&index=1&id=7d8c71ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports